import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from "src/common/constants";
import { TasksPriorities, TasksStatuses } from "src/modules/3rd-party-management/constants";

import styles from "../../styles";
import { EntityRecordsTable, SectionTitle } from "../../shared";

const TASK_COLUMNS = [
    { key: "taskId", label: "Task ID", width: "9%" },
    { key: "title", label: "Title", width: "22%" },
    { key: "createdAt", label: "Created", width: "11%" },
    { key: "deadline", label: "Deadline", width: "11%" },
    { key: "manager", label: "Manager", width: "13%" },
    { key: "owner", label: "Owner", width: "13%" },
    { key: "priority", label: "Priority", width: "10%" },
    { key: "status", label: "Status", width: "11%" },
];

const formatTimestamp = (dateUtils, timestamp) => {
    if (!timestamp) {
        return null;
    }

    return dateUtils.convertTimeStampToDate(timestamp, INTERNATIONAL_DATE_FORMAT);
};

const TaskManagementSection = ({ t, supplierData = {}, meta }) => {
    const dateUtils = new DateUtils();
    const tasks = Array.isArray(supplierData?.tasks) ? supplierData.tasks : [];

    const records = tasks.map((task, index) => ({
        id: task?.id || `task-${index}`,
        taskId: `T${task?.secondary_id || "-"}`,
        title: task?.name,
        createdAt: formatTimestamp(dateUtils, task?.created_at),
        deadline: formatTimestamp(dateUtils, task?.ended_at),
        manager: task?.manager,
        owner: task?.analyst?.full_name,
        priority: TasksPriorities[task?.priority]?.title || null,
        status: TasksStatuses[task?.status]?.title || task?.status || null,
    }));

    return (
        <View style={styles.wordSectionContent}>
            <EntityRecordsTable
                columns={TASK_COLUMNS}
                records={records}
                leading={(
                    <SectionTitle
                        title={meta?.title || "Task Management"}
                        number={meta?.number}
                        anchorId={meta?.anchorId}
                    />
                )}
            />

            {tasks.length > 0 && (
                <View style={localStyles.statusSummaryWrap}>
                    <Text style={localStyles.statusSummaryText}>
                        {`${t("New")}: ${tasks.filter((task) => task?.status === "NEW").length} | `}
                        {`${t("Review")}: ${tasks.filter((task) => task?.status === "REVIEW").length} | `}
                        {`${t("In Progress")}: ${tasks.filter((task) => task?.status === "IN_PROGRESS").length}`}
                    </Text>
                </View>
            )}
        </View>
    );
};

const localStyles = {
    statusSummaryWrap: {
        paddingHorizontal: 30,
        marginTop: 6,
        marginBottom: 10,
    },
    statusSummaryText: {
        fontSize: 8,
        color: "#1F2937",
    },
};

export default withNamespaces()(TaskManagementSection);
